import { gql } from 'apollo-angular';

export default gql`
  fragment AnnouncementFields on Announcement {
    id
    title
    appType
    messages {
      nl_NL
      de_DE
      en_US
      fr_FR
      fi_FI
    }
    start_date
    end_date
  }

  query ListAnnouncements {
    listAnnouncements {
      ...AnnouncementFields
    }
  }

  mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
    createAnnouncement(input: $input) {
      ...AnnouncementFields
    }
  }

  mutation UpdateAnnouncement($input: UpdateAnnouncementInput!) {
    updateAnnouncement(input: $input) {
      ...AnnouncementFields
    }
  }

  mutation DeleteAnnouncement($id: ID!) {
    deleteAnnouncement(id: $id) {
      id
    }
  }

  subscription OnAnnouncementChanged {
    onAnnouncementChanged {
      id
      event_type
    }
  }
`;
